// Unpublished Work © 2026 Deere & Company.

import React from 'react';
import JdAgLogo from '/assets/logo.svg';

export const LandingPageHeader = ({isMobile}: {isMobile: boolean}): React.ReactElement => (
    <header className={`flex flex-row items-center bg-white font-normal gap-4 h-[56px] px-4 fixed top-0 w-full z-[1]`}>
        <img alt='John Deere' className={isMobile ? 'h-6 w-[124.5px]' : 'h-9 w-[186.75px]'} src={JdAgLogo} />
        {!isMobile && <div className='border-l border-black h-6 m-0 opacity-[0.24]' />}
        <h2 className='headerText text-[#367c2b] m-0'>{'Operations Center'}</h2>
    </header>
);
